// Ventajas: [
//   "Pagos incluidos al mes",
//   "Comisión por pago exitoso adicional",
//   "Personaliza con tu logo y colores",
//   "Quick Transfer",
//   "Payment Links",
//   "Evolución de los pagos y analítica",
//   "Multiples comercios",
//   "",
//   "Administración",
//   "Usuarios de gestión",
//   "Administración de roles de seguridad",
//   "",
//   "Soporte",
//   "Atención en horario de oficina",
//   "Correo electrónico",
//   "Chat en línea",
//   "Atención prioritaria 24/7",
//   "Reporte de incidencias",
//   "Gestor de cuenta dedicado (KAM)",
// ];
export const dataAllCH2 = [
  {
    title: "Quick Transfer",
    basicCheck: true,
    starterCheck: true,
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Payment Links",
    basic: "",
    starterCheck: true,
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Pagos incluidos al mes",
    basic: "Paga por uso",
    starter: "200",
    plus: "400",
    enterprise: "A la medida",
  },
  {
    title: "Comisión por pago exitoso adicional",
    text: "Cuando superes la cantidad de pagos al mes incluidos en tu plan no interrumpiremos tu servicio. En su lugar, te cobraremos una comisión por pago exitoso adicional.",
    basic: "",
    starter: "0,95%",
    starterCheck: true,
    plus: "0,90%",
    plusCheck: true,
    enterprise: "A la medida",
    enterpriseCheck: true,
  },
  {
    title: "Débito Directo (PAC)",
    titleSup: "1",
    text: "El precio por transacción será de:",
    text2:
      "Monto mínimo de Tope Mínimo por Transacción: 0,019 UF+IVA (valor aproximado a 700 CLP) y un monto máximo Tope Máximo por Transacción: 0,041 UF+IVA (valor aproximado a 1.480 CLP)",
    textSup2: "1",
    starterCheck: true,
    starter: "0,95%",
    plusCheck: true,
    plus: "0,90%",
    enterprise: "A la medida",
    enterpriseCheck: true,
  },
  {
    title: "Business Transfer",
    titleSup: "2",
    text: "El precio por transacción será de:",
    text2:
      "Tope máximo por transacción: 0,069 UF + IVA (valor aproximado a 2.500 CLP)",
    textSup2: "2",
    starterCheck: true,
    starter: "1%",
    plusCheck: true,
    plus: "1%",
    enterprise: "A la medida",
    enterpriseCheck: true,
  },
  {
    title: "Personaliza con tu logo y colores",
    basicCheck: true,
    starterCheck: true,
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Evolución de los pagos y analítica",
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Múltiples comercios",
    tooltip:
      "Gestiona y unifica todas las transacciones en un solo lugar. Para empresas con más de una tienda o negocio.",
    enterpriseCheck: true,
  },
  { fullTitle: "Administración" },
  {
    title: "Usuarios de gestión",
    basic: "1",
    starter: "2",
    plus: "5",
    enterprise: "Ilimitados",
  },
  {
    title: "Administración de roles de seguridad",
    plusCheck: true,
    enterpriseCheck: true,
  },
  { fullTitle: "Soporte" },
  {
    title: "Atención en horario de oficina",
    tooltip: "De Lunes a Viernes de 9:00 a 18:00 Hrs",
    basicCheck: true,
    starterCheck: true,
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Correo electrónico",
    basicCheck: true,
    starterCheck: true,
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Chat en línea",
    starterCheck: true,
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Atención prioritaria 24/7",
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Reporte de incidencias",
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Gestor de cuenta dedicado (KAM)",
    enterpriseCheck: true,
  },
];

export const dataAllCH = {
  Ventajas: [
    "Quick Transfer",
    "Payment Links",
    "Pagos incluidos al mes",
    "Comisión por pago exitoso adicional",
    "",
    "Debito directo(PAC)",
    "Multiples comercios",
    "",
    "Administración",
    "Usuarios de gestión",
    "Administración de roles de seguridad",
    "",
    "Soporte",
    "Atención en horario de oficina",
    "Correo electrónico",
    "Chat en línea",
    "Atención prioritaria 24/7",
    "Reporte de incidencias",
    "Gestor de cuenta dedicado (KAM)",
  ],
  Starter: [
    "Paga por uso",
    "",
    "Si",
    "Si",
    "",
    "",
    "",
    "",
    "",
    "1",
    "",
    "",
    "",
    "Si",
    "Si",
  ],
  "": [],
  Lite: [
    "200",
    "0,95%",
    "Si",
    "Si",
    "Si",
    "",
    "",
    "",
    "",
    "2",
    "",
    "",
    "",
    "Si",
    "Si",
    "Si",
  ],
  " ": [],
  Plus: [
    "400",
    "0,90%",
    "Si",
    "Si",
    "Si",
    "Si",
    "",
    "",
    "",
    "5",
    "Si",
    "",
    "",
    "Si",
    "Si",
    "Si",
    "Si",
    "Si",
  ],
  "  ": [],
  Enterprise: [
    "A la medida",
    "A la medida",
    "Si",
    "Si",
    "Si",
    "Si",
    "Si",
    "",
    "",
    "Ilimitados",
    "Si",
    "",
    "",
    "Si",
    "Si",
    "Si",
    "Si",
    "Si",
    "Si",
  ],
};
export const dataBeginnerCH = {
  Ventajas: [
    "Pagos incluidos al mes",
    "Comisión por pago exitoso adicional",
    "Quick Transfer",
    "Payment Links",
    "Multiples comercios",
    "Personaliza con tu logo y colores",
    "",
    "Administración",
    "Usuarios de gestión",
    "Administración de roles de seguridad",
    "",
    "Soporte",
    "Atención en horario de oficina",
    "Correo electrónico",
    "Chat en línea",
    "Atención prioritaria 24/7",
    "Reporte de incidencias",
    "Gestor de cuenta dedicado (KAM)",
  ],
  Starter: [
    "Paga por uso",
    "1%",
    "Si",
    "Si",
    "",
    "Si",
    "",
    "",
    "1",
    "",
    "",
    "",
    "Si",
    "Si",
  ],
  "": [],
  Lite: [
    "200",
    "0,9%",
    "Si",
    "Si",
    "",
    "Si",
    "",
    "",
    "2",
    "",
    "",
    "",
    "Si",
    "Si",
    "Si",
  ],
};
export const dataPremiumCH = {
  Ventajas: [
    "Pagos incluidos al mes",
    "Comisión por pago exitoso adicional",
    "Quick Transfer",
    "Payment Links",
    "Multiples comercios",
    "Personaliza con tu logo y colores",
    "",
    "Administración",
    "Usuarios de gestión",
    "Administración de roles de seguridad",
    "",
    "Soporte",
    "Atención en horario de oficina",
    "Correo electrónico",
    "Chat en línea",
    "Atención prioritaria 24/7",
    "Reporte de incidencias",
    "Gestor de cuenta dedicado (KAM)",
  ],
  Plus: [
    "400",
    "0,85%",
    "Si",
    "Si",
    "",
    "Si",
    "",
    "",
    "5",
    "Si",
    "",
    "",
    "Si",
    "Si",
    "Si",
    "Si",
    "Si",
  ],
  "  ": [],
  Enterprise: [
    "A la medida",
    "A la medida",
    "Si",
    "Si",
    "Si",
    "Si",
    "",
    "",
    "Ilimitados",
    "Si",
    "",
    "",
    "Si",
    "Si",
    "Si",
    "Si",
    "Si",
    "Si",
  ],
};
